export enum StatusOptionsEnum {
  All = "ALL",
  Active = "ACTIVE",
  Inactive = "INACTIVE"
}
